export const getCountriesEndpoint = () => 'Country';
export const getCountryZipEndpoint = (country) => `Country/${country}:zip`;
export const getCountryProvincesEndpoint = (country) => `Country/${country}:provinces`;